// extracted by mini-css-extract-plugin
export var shake = "_5-1";
export var toastCloseButton = "_5-0";